export const ScriptLoaderProtocol = {
    AUTO: 'auto',
    HTTP: 'http',
    HTTPS: 'https'
};
